module.exports = __webpack_public_path__ + "img/bg_img_hero_org.53afe8e4.png";